var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.calc-modal",modifiers:{"calc-modal":true}}],staticClass:"help-btn",style:({width: _vm.width})},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }